<eventq-dialog-popover
  [open]="open()"
  title="Close Event"
  [cancelLabel]="cancelLabel()"
  [confirmLabel]="confirmLabel()"
  [confirmDisabled]="confirmDisabled()"
  [anchor]="anchor()"
  [placement]="resolvedPlacement()"
  [panelWidth]="panelWidth()"
  (closed)="closed.emit()"
  (confirmed)="onConfirm()"
>
  <div class="close-event-popover__outcomes">
    <h3 class="close-event-popover__heading">Choose Outcome</h3>

    <eventq-popover-search
      [value]="searchQuery()"
      (valueChange)="searchQueryChange.emit($event)"
    />

    <eventq-priority-filter-row
      [options]="priorityOptions()"
      [selectedPriorities]="selectedPriorities()"
      (selectedPrioritiesChange)="selectedPrioritiesChange.emit($event)"
    />

    <eventq-event-outcome-list
      [groups]="groups()"
      [selectedOutcomeId]="selectedOutcomeId()"
      [selectedPriorities]="selectedPriorities()"
      [searchQuery]="searchQuery()"
      maxHeight="none"
      (selectedOutcomeIdChange)="selectedOutcomeIdChange.emit($event)"
    />
  </div>

  <div class="close-event-popover__details">
    <eventq-input
      label="Closing Details"
      placeholder="Add closing details of this event"
      [multiline]="true"
      [maxLength]="closingDetailsMaxLength"
      [validateRequired]="true"
      [requiredIndicator]="true"
      [submitAttempted]="submitAttempted()"
      [value]="closingDetails()"
      (valueChange)="closingDetailsChange.emit($event)"
    />
  </div>
</eventq-dialog-popover>
